type AmbientOrbitProps = {
  side?: "left" | "right";
};

export function AmbientOrbit({ side = "left" }: AmbientOrbitProps) {
  return (
    <div className={`ambient-orbit ambient-orbit--${side}`} aria-hidden="true">
      <span className="ambient-orbit__arc ambient-orbit__arc--one" />
      <span className="ambient-orbit__arc ambient-orbit__arc--two" />
      <span className="ambient-orbit__node ambient-orbit__node--one" />
      <span className="ambient-orbit__node ambient-orbit__node--two" />
    </div>
  );
}
